/**
 * Adds an event listener for the 'cart:change' event.
 * Updates the cart item count after a delay.
 */

// Shared update logic
function updateCartCounters(quantity) {
  // Update cart quantity with label
  const counter = document.querySelector('[data-name="cart-quantity"]');
  if (counter) {
    if (quantity === 0) {
      counter.textContent = '';
    } else {
      const label = quantity > 1 ? 'items' : 'item';
      counter.textContent = `${quantity} ${label}`;
    }
  }

  // Update nav counter
  const navCounter = document.querySelector('[data-name="cart-count-nav"]');
  
  if (navCounter) {
    if (quantity === 0) {
      navCounter.textContent = '';
    } else {
      navCounter.textContent = quantity > 99 ? "∞" : quantity;
    }
  }

  // Update cart dot visibility
  const cartDot = document.querySelector('.header__cart-dot');
  
  if (cartDot) {
    if (quantity > 0) {
      cartDot.classList.add('is-visible');
    } else {
      cartDot.classList.remove('is-visible');
    }
  }
}

// Initialize on page load
(async function() {
  try {
    const cart = await (await fetch(`${Shopify.routes.root}cart.js?t=${Date.now()}`)).json();
    updateCartCounters(cart.item_count);
  } catch (error) {
    console.error('Error initializing cart counter:', error);
  }
})();

document.addEventListener("cart:change", async function (event) {
  upsellNavigation();
  toggleUpsellVisibility();

  // Always fetch fresh cart data with cache-busting to avoid stale data on translated pages
  try {
    const freshCart = await (await fetch(`${Shopify.routes.root}cart.js?t=${Date.now()}`)).json();
    updateCartCounters(freshCart.item_count);
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
});

document.addEventListener("cart:refresh", async () => {
  upsellNavigation();
  toggleUpsellVisibility();

  // Get cart data with cache-busting and update counters
  try {
    const response = await fetch(`/cart.js?t=${Date.now()}`);
    const cart = await response.json();
    updateCartCounters(cart.item_count);
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
});

function incrementCartCount() {
  upsellNavigation();
  toggleUpsellVisibility();
  document.querySelector('[data-name="cart-count-nav"]').textContent = Number(document.querySelector('[data-name="cart-count-nav"]').textContent) + 1;
}

